export function getServerErrorMessage(error) {
  let { message } = error;
  if (!message) {
    if (error?.errors && Object.keys(error.errors).length > 0)
      message = Object.values(error.errors).reduce((acc, v) => {
        if (acc) return `${acc}, ${v}`;
        return v;
      }, '');
  }
  if (!message) message = 'Server Error! Please retry later.';
  return message;
}
